import styled from 'styled-components'

import { COLOURS } from 'resources'
import RoundedButton from 'components/RoundedButton'

export const Button = styled(RoundedButton)`
  margin-top: 30px;
  width: 100%;
`

export const Description = styled.div`
  margin-top: 30px;
`
export const DescriptionContent = styled.div`
  font-weight: bold;
  word-break: break-word;
`

export const SupportLink = styled.a`
  color: ${COLOURS.primaryBlue};

  &:hover {
    text-decoration: none;
    opacity: 0.7;
  }
`
